// extracted by mini-css-extract-plugin
export default {"why":"Why_why__Teuee","whyBody":"Why_whyBody__hupom"};